module.exports = __webpack_public_path__ + "static/img/header-background.3962df37.jpg";